import React from 'react';
import { Link } from 'react-router-dom';
import { Clipboard } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-12 px-4 sm:px-6 lg:px-8 border-t border-slate-700 bg-slate-900">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <Link to="/" className="flex items-center space-x-3 mb-4 md:mb-0">
            <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center">
              <Clipboard className="w-5 h-5 text-white" />
            </div>
            <span className="text-lg font-bold text-white">DAS Cloud Engineering</span>
          </Link>
          <div className="text-slate-400 text-sm text-center md:text-right">
            © 2025 DAS Cloud Engineering LLC. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;